export const currentActionNames = {
	value: new Set<string>(),
};
